import { Component, inject, OnInit } from '@angular/core';

import { LeadService } from "../services/leads/lead.service";
import { MatTableModule } from "@angular/material/table";
import { ExaminationResultService } from '../lead-dashboard/lead-task/lead-task-services/examination-result.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-admin-panel',
  imports: [MatTableModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './admin-panel.component.html',
  styleUrl: './admin-panel.component.scss',
})
export class AdminPanelComponent implements OnInit {
  private readonly leadService = inject(LeadService);
  private readonly resultService = inject(ExaminationResultService);
  private readonly _snackBar = inject(MatSnackBar);

  errorLeads = this.leadService.errorLeads;

  displayedColumns: string[] = ['id', 'name', 'category', 'actions'];

  retryingLeadId: string | null = null;

  ngOnInit(): void {
    this.leadService.fetchErrorLeads();
  }

  retryLead(leadId: string): void {
    this.retryingLeadId = leadId;
    this.resultService.retryUploadToSap(leadId).subscribe({
      next: () => {
        this.leadService.fetchErrorLeads();
        this._snackBar.open('Lead retried successfully', 'Close', {});
        this.retryingLeadId = null;
      },
      error: (err) => {
        console.error('Error retrying lead:', err);
        this._snackBar.open('Failed to retry lead', 'Close', {duration: 3000});
        this.retryingLeadId = null;
      }
    });
  }

  isRetrying(leadId: string): boolean {
    return this.retryingLeadId === leadId;
  }
}
